
import React from "react";
import HouseSelection from "../../Statistic/HouseSelection";
import FloorSelection from "../../Statistic/floorSelection";
import { Filters, Select } from "../design";

const TaskFilters = ({
                         houses,
                         Floors,
                         selectedHouse,
                         setSelectedHouse,
                         selectedFloor,
                         setSelectedFloor,
                         statusFilter,
                         setStatusFilter
                     }) => {
    function changeHouse(house) {
        setSelectedHouse(house);
        setSelectedFloor("");
    }

    return (
        <>
            <HouseSelection
                houses={houses}
                selectedHouse={selectedHouse}
                setSelectedHouse={changeHouse}
                allowAll
            />
            <FloorSelection
                Floors={Floors}
                selectedHouse={true}
                selectedFloor={selectedFloor}
                setSelectedFloor={floor => {
                    setSelectedFloor(
                        selectedFloor === floor ? "" : floor
                    );
                }}
            />



            <Filters>
                <Select
                    value={statusFilter}
                    onChange={e =>
                        setStatusFilter(e.target.value)
                    }
                >
                    <option value="all">Alle Aufgaben</option>
                    <option value="open">Offen</option>
                    <option value="done">Erledigt</option>
                </Select>
            </Filters>
        </>
    );
};

export default TaskFilters;
